import React, { Component } from "react";
import _find from "lodash/find";
import PropTypes from "prop-types";
import { Translate } from "react-localize-redux";
import {
  getAddressField,
  getContactNumber,
  getFullName,
  getEmail,
  getPhotoUrl, PUBLIC, MY_CONTACTS
} from "../../utils/profilePrivacy";
import "./styles.scss";
import ContactsTable from "../ContactsTable";
import SocialLink from "../SocialLink";

class PhotoSearchCard extends Component {
  isContact(itemId) {
    if (this.props.contacts) {
      return _find(this.props.contacts, contact => contact.id === itemId);
    }
    return false;
  }

  renderSocialAccounts = accounts =>
    accounts &&
    accounts.map(
      account =>
        account.name && (
          <SocialLink key={`${Math.random()}`} socialItem={account} />
        )
    );

  renderAddRemoveContact = ({
    isUserLoggedIn,
    showAdd,
    rowItem,
    onAdd,
    showRemove,
    onRemove,
    showAddToCookie,
  }) => (
    <React.Fragment>
      {!isUserLoggedIn && showAddToCookie && (
        <a
          className="btn grey-btn contact-btn"
          onClick={e => {
            e.stopPropagation();
            onAdd(rowItem.id);
          }}
        >
          <Translate id="addText" />
        </a>
      )}
      {isUserLoggedIn &&
        showAdd &&
        !this.isContact(rowItem.id) && (
          <a
            className="btn grey-btn contact-btn"
            onClick={e => {
              e.stopPropagation();
              onAdd(rowItem.id);
            }}
          >
            <Translate id="addText" />
          </a>
        )}
      {isUserLoggedIn &&
        showRemove &&
        this.isContact(rowItem.id) && (
          <a
            className="btn grey-btn contact-btn"
            onClick={e => {
              e.stopPropagation();
              onRemove(this.isContact(rowItem.id).id);
            }}
          >
            <Translate id="removeText" />
          </a>
        )}
    </React.Fragment>
  );

  render() {
    const {
      rowItem,
      fullCard,
      showContacts,
      onClick,
      loggedInUser
    } = this.props;

    const isContact = (profileId, contacts) => {
      if (this.props.contacts) {
        return _find(contacts, contact => contact.id === profileId);
      }
      return false;
    }


    const city_district = getAddressField(rowItem, loggedInUser, "city_district");
    const country = getAddressField(rowItem, loggedInUser, "country");

    const _targetProfile = loggedInUser.id === rowItem.id ? loggedInUser : rowItem;
    const _contacts = _targetProfile.contacts;

    const _allowedToViewContacts = () => {
      if(!rowItem || loggedInUser.id === rowItem.id) {
        return true;
      }

      const _isContact = isContact(rowItem.id, loggedInUser.contacts);
      const contactsPrivacy = rowItem.privacy;

      switch (contactsPrivacy) {
        case PUBLIC:
          return true;
        case MY_CONTACTS:
          return _isContact;
        default:
          return false;
      }
    }

    return (
      <div
        className={
          fullCard ? "card-container card-container--lg" : "card-container"
        }
        onClick={onClick}
      >
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 contact-img-container">
            <div
              className={fullCard ? "search-card-img-lg" : "search-card-img"}
              style={{
                backgroundImage: `url(${getPhotoUrl(rowItem, loggedInUser)})`
              }}
            />
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12">
            <div className="row" />
            <div className="row profile-details-container">
              <div className="col-12 add-contact-btn-container">
                {this.renderAddRemoveContact(this.props)}
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 search-card-name">
                <h3 className="search-card-name-text">
                  {getFullName(rowItem, loggedInUser)}
                </h3>
              </div>
              <div className={`col-12 detail-flex-text ${fullCard ? 'lg-standard-text': ''}`}>
                {city_district}
                {city_district && country ? ", ": ""}
                {country}
              </div>
              <div className={`col-12 detail-flex-text ${fullCard ? 'lg-standard-text': ''}`}>
                {getContactNumber(rowItem, loggedInUser)}
              </div>
              <div className={`col-12 detail-flex-text ${fullCard ? 'lg-standard-text': ''}`}>
                {getEmail(rowItem, loggedInUser)}
              </div>
            </div>
          </div>
        </div>
        {/*{fullCard && (*/}
          <div className="row social-row justify-content-flex-start">
            {this.renderSocialAccounts(rowItem.social_accounts)}
          </div>
        {/*)}*/}

        {/*{_allowedToViewContacts && _contacts.length > 0 && showContacts && (*/}
        {/*  <div>*/}
        {/*    <br />*/}
        {/*    <h3 className="header-text">Contacts</h3>*/}
        {/*    <ContactsTable*/}
        {/*      contacts={loggedInUser.id === rowItem.id ? loggedInUser.contacts : rowItem.contacts}*/}
        {/*      showContactAction={loggedInUser.id === rowItem.id}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
    );
  }
}

PhotoSearchCard.propTypes = {
  rowItem: PropTypes.object,
  fullCard: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  loggedInUser: PropTypes.object,
  showContacts: PropTypes.bool,
  showShare: PropTypes.bool,
  showAdd: PropTypes.bool,
  showRemove: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func
};

PhotoSearchCard.defaultProps = {
  showContacts: true,
  showShare: false,
  showAdd: true,
  showRemove: true
};

export default PhotoSearchCard;



// WEBPACK FOOTER //
// ./src/components/PhotoSearchCard/PhotoSearchCard.jsx